import Box from '@mui/material/Box';
import { createFileRoute } from '@tanstack/react-router';
import { SignInForm } from '../features/auth/SignInForm';
import { useAuthStore } from '../stores/auth';

function LoginPage() {
  const requestLink = useAuthStore((s) => s.requestLink);
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8, px: 2 }}>
      <SignInForm onRequest={requestLink} />
    </Box>
  );
}

export const Route = createFileRoute('/login')({ component: LoginPage });
